import React from 'react';

const ValidationAlert = ({ errors }) => {
    if (!errors || errors.length === 0) return null;
    return <div className="invalid" role="alert" dangerouslySetInnerHTML={{ __html: errors.join('<br/>') }}></div>
}

export default ValidationAlert;